import { useState } from 'react';
import * as C from './App.styles';
import { AddArea } from './components/AddArea';
import { ListItem } from './components/ListItem';
import { Item } from './types/Item';

const App = () => {
  const [list, setList] = useState<Item[]>([
    {id: 1, name: 'Comprar pão na padaria', done: false},
    {id: 2, name: 'Comprar um bolo na padaria', done: true}
  ]);

  const handleAddTask = (taskName: string) => {
    let newList = [...list];
    newList.push({
      id: list.length + 1,
      name: taskName,
      done: false
    });
    setList(newList);
  }

  const handleUpdateTask = (item: Item)  => {   
    let newList = [...list];
    newList.filter((obj) => {
      if(obj === item){
        obj.done = item.done;
        console.log(obj);
      }      
    });
    setList(newList);    
  }

  return (
    <C.Container>
      <C.Area>
        <C.Header>Lista de tarefas</C.Header>

        <AddArea onEnter={handleAddTask}></AddArea>

        {list.map((item, index) =>(
          <ListItem key={index} item={item} onUpdate={handleUpdateTask}></ListItem>
        ))}


      </C.Area>
    </C.Container>
  );
}

export default App;